module.exports = __webpack_public_path__ + "media/honey-icons/icon-battery-full-7cb72bf6.svg";